<template>
  <div class="home">
    <div class="top">
      <van-popup
        v-model="confirmLeaveShow"
        get-container="body"
        :style="{ height: '85%', width: '90%' }"
        :closeable="true"
      >
        <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
          访客信息
        </div>
        <div v-for="(item, index) in confirmLeaveForm.visitors" :key="index">
          <div
            class="bgwhite yellow2 ft30 pl30 bor-bt"
            style="height: 5.5vh; line-height: 5.5vh"
          >
            访客{{ index + 1 }}
          </div>
          <van-cell-group class="plr20">
            <van-cell title="访客姓名" :value="item.personName" />
            <van-cell title="身份证号" :value="item.personNo" />
            <van-field label="出入卡">
              <template #input>
                <van-radio-group v-model="item.hasPass" direction="horizontal">
                  <van-radio :name="0">有</van-radio>
                  <van-radio :name="1">无</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-if="item.hasPass == 0"
              v-model="item.passNo"
              label="出入卡编号"
              placeholder="请输入出入卡编号"
            />
            <van-field label="上岗证">
              <template #input>
                <van-radio-group
                  v-model="item.hasWorklicense"
                  direction="horizontal"
                >
                  <van-radio :name="0">有</van-radio>
                  <van-radio :name="1">无</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-if="item.hasWorklicense == 0"
              v-model="item.worklicenseNo"
              label="上岗证编号"
              placeholder="请输入上岗证编号"
            />
          </van-cell-group>
        </div>
        <div style="width: 90%; margin: 5px" class="flex w100">
          <van-button
            type="danger"
            class="flex1 w47"
            @click="confirmLeaveSubmit()"
            >确认离矿</van-button
          >
          <van-button
            style="margin-left: 5px"
            type="info"
            class="flex1 w47"
            @click="confirmLeaveShow = false"
            >关闭</van-button
          >
        </div>
      </van-popup>
      <van-popup
        v-model="show"
        get-container="body"
        :style="{ height: '85%', width: '90%' }"
        :closeable="true"
      >
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            被访者信息
          </div>
          <van-cell-group class="plr20">
            <van-cell title="被访者姓名" :value="showForm.intervieweeName" />
            <van-cell title="被访者电话" :value="showForm.intervieweePhone" />
            <van-cell title="访问时间" :value="showForm.interviewTime" />
            <van-cell title="结束时间" :value="showForm.leaveTime" />
            <van-cell
              v-if="showForm.confirmTime"
              title="离矿时间"
              :value="showForm.confirmTime"
            />
          </van-cell-group>
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            来访单位信息
          </div>
          <van-cell-group class="plr20">
            <van-cell title="来访单位" :value="showForm.company" />
            <van-cell title="车牌号" :value="showForm.carNo" />
            <van-cell title="来访事由" :value="showForm.reason" />
          </van-cell-group>
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            访客信息
          </div>
          <div v-for="(item, index) in showForm.visitors" :key="index">
            <div
              class="bgwhite yellow2 ft30 pl30 bor-bt"
              style="height: 5.5vh; line-height: 5.5vh"
            >
              访客{{ index + 1 }}
            </div>
            <van-cell-group class="plr20">
              <van-cell title="访客姓名" :value="item.personName" />
              <van-cell title="身份证号" :value="item.personNo" />
              <van-cell title="访客电话" :value="item.personPhone" />
              <van-cell title="性别" :value="item.sex ? '女' : '男'" />
              <van-cell title="年龄" :value="item.age" />
              <van-cell
                title="出入卡"
                :value="item.hasPass == 0 ? item.passNo : '无'"
              />
              <van-cell
                title="上岗证"
                :value="item.hasWorklicense == 0 ? item.worklicenseNo : '无'"
              />
              <!--健康码改为附件20240721-->
              <div class="flex alstart between mt20">
                <span class="ft30 w40">附件</span>
                <template v-if="item.healthCode.indexOf(';') != -1">
                  <div class="flex flex1" style="flex-wrap: wrap">
                    <van-image
                      width="20vw"
                      height="20vw"
                      v-for="(i, v) in item.healthCode.split(';')"
                      :key="v"
                      :src="showForm.imgUrl + i"
                      @click="imagePreview(item, v, 1)"
                      style="display: flex; padding: 0 1vw 1vw 0"
                    >
                      <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                      </template>
                    </van-image>
                  </div>
                </template>
                <template v-else>
                  <div class="flex flex1" style="flex-wrap: wrap">
                    <van-image
                      width="20vw"
                      height="20vw"
                      :src="showForm.imgUrl + item.healthCode"
                      @click="imagePreview(item, 0, 1)"
                      style="padding: 0 1vw 1vw 0"
                    >
                      <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                      </template>
                    </van-image>
                  </div>
                </template>
              </div>
              <!--健康码改为附件20240721-->
              <!--屏蔽掉健康码相关信息20240721-->
              <div v-if="$globalJKM">
                <van-cell title="目前居住地" :value="item.apartment" />
                <van-cell title="近7天行程" :value="item.journey" />
                <van-cell title="来杭交通方式" :value="item.transport" />
                <van-cell
                  title="发热咳嗽"
                  :value="item.hasCough ? '是' : '否'"
                />
                <van-cell
                  title="来自中高风险区"
                  :value="item.hasRisk ? '是' : '否'"
                />
                <div class="flex alstart between mt20">
                  <span class="ft30 w40">健康码</span>
                  <template v-if="item.healthCode.indexOf(';') != -1">
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        v-for="(i, v) in item.healthCode.split(';')"
                        :key="v"
                        :src="showForm.imgUrl + i"
                        @click="imagePreview(item, v, 1)"
                        style="display: flex; padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        :src="showForm.imgUrl + item.healthCode"
                        @click="imagePreview(item, 0, 1)"
                        style="padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                </div>

                <div class="flex alstart between mt20">
                  <span class="ft30 w40">核酸检测报告</span>
                  <template v-if="item.acidCode.indexOf(';') != -1">
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        v-for="(i, v) in item.acidCode.split(';')"
                        :key="v"
                        :src="showForm.imgUrl + i"
                        @click="imagePreview(item, v, 3)"
                        style="display: flex; padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex flex1" style="flex-wrap: wrap">
                      <van-image
                        width="20vw"
                        height="20vw"
                        :src="showForm.imgUrl + item.acidCode"
                        @click="imagePreview(item, 0, 3)"
                        style="padding: 0 1vw 1vw 0"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                  </template>
                </div>
              </div>
              <!--屏蔽掉健康码相关信息20240721-->
            </van-cell-group>
          </div>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false"
              >关闭</van-button
            >
          </div>
        </div>
      </van-popup>

      <div class="homes">
        <van-tabs v-model="active" @click="initContent" color="#4597ff">
          <van-tab title="当前预约">
            <div>
              <van-popup
                v-model="nishow"
                get-container="#app"
                round
                position="center"
                :style="{ height: '70%', width: '90%' }"
                :close-on-click-overlay="false"
              >
                <div class="m30 relative">
                  <div
                    class="ft30 bold ptb20 tc fixed w90"
                    style="position: fixed !important"
                  >
                    <div class="tc">入厂人员安全告知</div>
                  </div>
                  <div class="ptb20 tc" style="height: 20px"></div>
                  <div class="ft28">
                    <div class="">
                      各位领导、客户及来访者，欢迎光临我司检查、参观、联系业务。为保证大家的人身健康与安全，请配合公司熟悉并遵守如下规定：
                    </div>
                    <div class="mt10">
                      1、进入公司前请在公司值班室配合保安人员进行必要登记及出示相关证件。进入厂区、库区的所有车辆请按照限速标志行驶，并按照指定地点停放。严禁酒后进入公司。
                    </div>
                    <div class="mt10">
                      2、请在指定地点（办公室或休息室吸烟点）吸烟，烟头要丢在烟灰缸内，厂区内禁止流动吸烟。
                    </div>
                    <div class="mt10">
                      3、严禁携带易燃、易爆和其他危险化学品进入公司厂区、库区，进入库区人员请在库区入口处交出火种。
                    </div>
                    <div class="mt10">
                      4、如需将公司物资带出厂，请主动出示《物资放行申请单》。
                    </div>
                    <div class="mt10">
                      5、严禁私自进入生产区域，如需进入生产现场，请在公司陪同人员引导下沿指定的安全路线行走；进入生产现场，应遵守各种安全警示标志的提示，佩戴必要的劳动防护用品，做好个人防护。
                    </div>
                    <div class="mt10">
                      6、公司配有医务室，如有身体不适，可立即联系身边的陪同人员。参观期间，如有火灾、地震等突发情况，您可就近拿取附件的救援物资使用。撤离时，请您听从陪同人员的引导，按照疏散指示有序撤离。
                    </div>
                    <div class="mt10">
                      请您认真阅读安全告知，衷心感谢您的配合！
                    </div>
                    <div class="tc mt30">
                      <van-tag
                        type="success"
                        size="large"
                        @click="nishow = false"
                        >我已知晓</van-tag
                      >
                    </div>
                  </div>
                </div>
              </van-popup>
              <div class="modals bggrey">
                <van-form
                  ref="appForm"
                  @submit="onSubmit"
                  @failed="failed"
                  validate-trigger="onSubmit"
                  label-align="center"
                  :scroll-to-error="true"
                  :validate-first="true"
                >
                  <div
                    class="pl30 ft28"
                    style="height: 6.5vh !important; line-height: 6.5vh"
                  >
                    被访者信息
                  </div>
                  <van-field
                    v-model="appForm.intervieweeName"
                    name="被访者姓名"
                    label="被访者姓名"
                    placeholder="请输入被访者姓名"
                    :required="true"
                    :rules="[{ required: true, message: '请填写被访者姓名' }]"
                  />
                  <van-field
                    v-model="appForm.intervieweePhone"
                    name="被访者电话"
                    label="被访者电话"
                    placeholder="请输入被访者电话"
                    :required="true"
                    :rules="[{ required: true, message: '请填写被访者电话' }]"
                  >
                    <template #button>
                      <van-button
                        size="small"
                        type="primary"
                        native-type="button"
                        @click="checkPhone"
                        >校验</van-button
                      >
                    </template>
                  </van-field>
                  <van-field
                    readonly
                    clickable
                    name="calendar"
                    :value="appForm.interviewTime"
                    label="访问时间"
                    :required="true"
                    placeholder="点击选择时间"
                    @click="openPicker(1)"
                    :rules="[{ required: true, message: '请选择访问时间' }]"
                  />
                  <van-field
                    readonly
                    clickable
                    name="calendar"
                    :value="appForm.leaveTime"
                    label="结束时间"
                    :required="true"
                    placeholder="点击选择时间"
                    @click="openPicker(2)"
                    :rules="[{ required: true, message: '请选择结束时间' }]"
                  />
                  <div id="screen">
                    <van-popup
                      v-model="showCalendar"
                      get-container="#screen"
                      round
                      position="bottom"
                      :safe-area-inset-bottom="true"
                    >
                      <van-datetime-picker
                        v-if="showCalendar"
                        v-model="currentDate"
                        type="datetime"
                        title="选择时间"
                        item-height="7vh"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="onConfirm"
                        @cancel="cancel"
                      />
                    </van-popup>
                  </div>

                  <div
                    class="pl30 ft28"
                    style="height: 6.5vh !important; line-height: 6.5vh"
                  >
                    来访单位信息
                  </div>
                  <van-field
                    v-model="appForm.company"
                    name="来访单位"
                    label="来访单位"
                    placeholder="请输入来访单位"
                    :required="true"
                    :rules="[{ required: true, message: '请填写来访单位' }]"
                  />
                  <van-field
                    v-model="appForm.carNo"
                    name="车牌号"
                    label="车牌号"
                    placeholder="请输入车牌号"
                    :required="false"
                  />
                  <van-field
                    v-model="appForm.reason"
                    name="来访事由"
                    label="来访事由"
                    placeholder="请输入来访事由"
                    :required="true"
                    :rules="[{ required: true, message: '请填写来访事由' }]"
                  />
                  <div
                    class="pl30 ft28"
                    style="height: 6.5vh !important; line-height: 6.5vh"
                  >
                    访客信息
                  </div>
                  <div
                    class=""
                    v-for="(item, index) in appForm.visitors"
                    :key="index"
                  >
                    <div
                      class="bgwhite yellow2 pl30 bor-bt ft28 flex between"
                      style="height: 6.5vh !important; line-height: 6.5vh"
                    >
                      <span>访客{{ index + 1 }}</span>
                      <span
                        class="red w30 tc"
                        v-if="appForm.visitors.length > 1"
                        @click="delVis(index, item)"
                        >删除访客</span
                      >
                    </div>
                    <van-field
                      v-model="item.personName"
                      name="访客姓名"
                      label="访客姓名"
                      placeholder="请输入访客姓名"
                      :required="true"
                      :rules="[{ required: true, message: '请填写访客姓名' }]"
                    />
                    <van-field
                      v-model="item.personNo"
                      name="身份证号"
                      label="身份证号"
                      placeholder="请输入身份证号"
                      :required="true"
                      :rules="[{ required: true, message: '请填写身份证号' }]"
                    />
                    <van-field
                      v-model="item.personPhone"
                      name="访客电话"
                      label="访客电话"
                      placeholder="请输入访客电话"
                      :required="true"
                      :rules="[{ required: true, message: '请填写访客电话' }]"
                    />
                    <van-field name="radio" label="性别">
                      <template #input>
                        <van-radio-group
                          v-model="item.sex"
                          direction="horizontal"
                        >
                          <van-radio :name="0">男</van-radio>
                          <van-radio :name="1">女</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                    <van-field
                      v-model="item.age"
                      label="年龄"
                      placeholder="请输入年龄"
                    />
                    <!-- <van-field label="出入卡">
												<template #input>
													<van-radio-group v-model="item.hasPass" direction="horizontal">
														<van-radio :name="0">有</van-radio>
														<van-radio :name="1">无</van-radio>
													</van-radio-group>
												</template>
											</van-field>
											<van-field v-if="item.hasPass==0" v-model="item.passNo" label="出入卡编号" placeholder="请输入出入卡编号" />
											<van-field label="上岗证">
												<template #input>
													<van-radio-group v-model="item.hasWorklicense" direction="horizontal">
														<van-radio :name="0">有</van-radio>
														<van-radio :name="1">无</van-radio>
													</van-radio-group>
												</template>
											</van-field>
											<van-field v-if="item.hasWorklicense==0" v-model="item.worklicenseNo" label="上岗证编号" placeholder="请输入上岗证编号" />
											 -->
                    <!--健康码改为附件20240721-->
                    <van-field
                      name="uploader"
                      label="附件"
                      :required="false"
                      :rules="[{ required: false, message: '请上传附近' }]"
                    >
                      <template #input>
                        <van-uploader
                          :name="1 + ',' + index"
                          :after-read="afterRead"
                          :multiple="true"
                          v-model="item.healthCodeList"
                        />
                      </template>
                    </van-field>
                    <!--屏蔽掉健康码相关信息20240721-->
                    <div v-if="$globalJKM">
                      <van-field
                        v-model="item.apartment"
                        name="目前居住地"
                        label="目前居住地"
                        placeholder="请输入目前居住地"
                        :required="true"
                        :rules="[
                          { required: true, message: '请填写目前居住地' },
                        ]"
                      />
                      <van-field
                        v-model="item.transport"
                        label="来杭交通方式"
                        placeholder="输入车次,航班,汽车等"
                        :required="true"
                        :rules="[
                          { required: true, message: '请填写来杭交通方式' },
                        ]"
                      />
                      <van-field name="radio" :required="true" label="发热咳嗽">
                        <template #input>
                          <van-radio-group
                            v-model="item.hasCough"
                            direction="horizontal"
                          >
                            <van-radio :name="0">否</van-radio>
                            <van-radio :name="1">是</van-radio>
                          </van-radio-group>
                        </template>
                      </van-field>
                      <van-field
                        name="uploader"
                        label="健康码"
                        :required="false"
                        :rules="[{ required: false, message: '请上传健康码' }]"
                      >
                        <template #input>
                          <van-uploader
                            :name="1 + ',' + index"
                            :after-read="afterRead"
                            :multiple="true"
                            v-model="item.healthCodeList"
                          />
                        </template>
                      </van-field>
                      <van-field name="uploader" label="核酸检测报告">
                        <template #input>
                          <van-uploader
                            :name="3 + ',' + index"
                            :after-read="afterRead"
                            :multiple="true"
                            v-model="item.acidCodeList"
                          />
                        </template>
                      </van-field>
                    </div>
                  </div>
                  <div
                    class="bor-top bgwhite flex between tc ft28"
                    style="height: 6.5vh !important; line-height: 6.5vh"
                  >
                    <span class="blue w50" @click="addVis">+添加访客</span>
                    <!-- <span class="red w50" v-if="appForm.visitors.length>1" @click="delVis">删除访客</span> -->
                  </div>
                  <!-- <div class="bgwhite" style="height: 60px !important;line-height: 60px!important;overflow: hidden !important;"> </div> -->

                  <div style="position: fixed; bottom: 0" class="flex w100">
                    <van-button
                      class="flex1 w47"
                      style="border-right: 3px solid #fff"
                      square
                      @click="reset"
                      block
                      type="info"
                      native-type="button"
                      >重置</van-button
                    >
                    <van-button
                      class="flex1 w50"
                      square
                      block
                      type="info"
                      native-type="submit"
                      >提交</van-button
                    >
                  </div>
                </van-form>
              </div>
            </div>
          </van-tab>
          <van-tab title="历史预约">
            <div>
              <van-pull-refresh
                class="bggrey"
                v-model="isLoading"
                @refresh="onRefresh"
              >
                <div class="autoFixed">
                  <van-list
                    v-model="loading"
                    :finished="finishedBottom"
                    finished-text="没有更多了"
                    @load="onLoad"
                  >
                    <van-cell
                      v-for="(item, index) in historyList"
                      :key="index"
                      style="margin-top: 20px; padding: 0"
                    >
                      <div class="main">
                        <div class="history-left" style="margin-top: 20px">
                          <div class="history-item">
                            <span>被访对象姓名：</span>
                            <span>{{ item.intervieweeName }}</span>
                          </div>
                          <div class="history-item">
                            <span>被访对象手机号：</span>
                            <span>{{ item.intervieweePhone }}</span>
                          </div>
                          <div class="history-item">
                            <span>来访事由：</span>
                            <span>{{ item.reason }}</span>
                          </div>
                          <div class="history-item">
                            <span>来访时间：</span>
                            <span>{{ item.interviewTime }}</span>
                          </div>
                          <div class="history-item">
                            <span>
                              访客姓名：
                              <span
                                v-for="(list, index1) in item.visitors"
                                :key="index1"
                              >
                                {{ list.personName }}
                                <span
                                  v-if="
                                    index1 < item.visitors.length - 1 &&
                                    item.visitors.length > 1
                                  "
                                  >、</span
                                >
                              </span>
                            </span>
                            <span>{{ item.personName }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">
                          <img
                            v-if="item.checkStatus == 0"
                            src="@/assets/visitor/daishenhe.png"
                            alt=""
                          />
                          <img
                            v-if="item.checkStatus == 1"
                            src="@/assets/visitor/agree.png"
                            alt=""
                          />
                          <img
                            v-if="item.checkStatus == 2"
                            src="@/assets/visitor/reject.png"
                            alt=""
                          />
                          <img
                            class="quxiao"
                            v-if="item.checkStatus == 9"
                            src="@/assets/sushe/quxiao.png"
                            alt=""
                          />
                        </div>
                        <van-button
                          plain
                          type="info"
                          size="small"
                          class="userBtn"
                          @click="cancleApp(item)"
                          v-if="item.checkStatus == 0"
                          >取消
                        </van-button>
                        <van-button
                          plain
                          type="primary"
                          size="small"
                          class="userBtn1"
                          @click="getDetail(item)"
                          >详情
                        </van-button>
                        <van-button
                          plain
                          type="info"
                          size="small"
                          class="userBtn2"
                          @click="goAgain(item)"
                          >重新预约
                        </van-button>
                        <!--审核通过后才能出现确认离矿-->
                        <van-button
                          v-if="!item.confirmTime && item.checkStatus == 1"
                          plain
                          type="info"
                          size="small"
                          class="userBtn3"
                          @click="confirmLeave(item)"
                          >确认离矿
                        </van-button>
                      </div>
                    </van-cell>
                  </van-list>
                </div>
              </van-pull-refresh>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import tabs from "@/components/tabs.vue";
import {
  addVisitor,
  visitorBlacklist,
  apptHistory,
  cancel,
  registerCheck,
  uploadImg,
  apppointConfirmLeave,
} from "@/apis/api";
import { Toast, Dialog, ImagePreview } from "vant";
import { formatTime1 } from "@/utils/index";
import { has } from "core-js/core/dict";
export default {
  data() {
    return {
      historyList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      active: 0,
      list: [
        {
          name: "当前预约",
          type: "current",
        },
        {
          name: "历史预约",
          type: "history",
        },
      ],
      minDate: new Date(2022, 1, 1),
      maxDate: new Date(2028, 10, 1),
      currentDate: new Date(),
      showForm: {},
      confirmLeaveForm: {},
      appForm: {
        intervieweeName: "",
        intervieweePhone: "",
        interviewTime: "",
        leaveTime: "",
        company: "",
        carNo: "",
        reason: "",
        openId: "",
        visitors: [
          {
            personName: "",
            personNo: "",
            personPhone: "",
            sex: 0,
            age: null,
            apartment: "",
            journey: "",
            transport: "",
            hasCough: 0,
            hasRisk: 0,
            healthCode: "",
            routeCode: "",
            acidCode: "",
            healthCodeList: [],
            routeCodeList: [],
            acidCodeList: [],
            hasPass: 1,
            passNo: "",
            hasWorklicense: 1,
            worklicenseNo: "",
          },
        ],
      },
      show: false,
      confirmLeaveShow: false,
      nishow: false,
      showPicker: false,
      showCalendar: false,
      picker_v: 1,
    };
  },
  beforeDestroy() {
    clearInterval(this.setTimer);
    this.setTimer = null;
  },
  mounted() {
    document.title = "访客预约";
    this.nishow = true;
  },
  methods: {
    imagePreview(item, list, index) {
      var images, arr;
      if (index == 1) {
        if (item.healthCode.indexOf(";") != -1) {
          arr = item.healthCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.healthCode];
        }
      } else if (index == 2) {
        if (item.routeCode.indexOf(";") != -1) {
          arr = item.routeCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.routeCode];
        }
      } else if (index == 3) {
        if (item.acidCode.indexOf(";") != -1) {
          arr = item.acidCode.split(";");
          for (let i = 0; i < arr.length; i++) {
            arr[i] = this.showForm.imgUrl + arr[i];
          }
          images = arr;
        } else {
          images = [this.showForm.imgUrl + item.acidCode];
        }
      }
      console.log(images);
      ImagePreview({
        images,
        startPosition: list,
        closeable: true,
      });
    },
    getDetail(item) {
      this.show = true;
      this.showForm = item;
    },
    confirmLeaveSubmit() {
      //提交者1为申请者，2为审核者
      this.confirmLeaveForm.submiter = 1;
      apppointConfirmLeave(this.confirmLeaveForm).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message);
          //刷新下页面
          this.confirmLeaveShow = false;
          this.onRefresh(1);
        } else {
          this.$toast(res.message);
        }
      });
    },
    confirmLeave(item) {
      this.confirmLeaveShow = true;
      this.confirmLeaveForm = item;
      // Dialog.confirm({
      // 	title: "提示",
      // 	message: `是否确认离矿？`,
      // }).then(() => {
      // 	apppointConfirmLeave({appointId:item.uid}).then(res => {
      // 		if (res.code == 200) {
      // 			this.$toast(res.message);
      // 			//刷新下页面
      // 			this.onRefresh(1);
      // 		} else {
      // 			this.$toast(res.message);
      // 		}

      // 	});
      // }).catch(() => {
      // });
    },
    goAgain(item) {
      this.appForm.intervieweeName = item.intervieweeName;
      this.appForm.intervieweePhone = item.intervieweePhone;
      this.appForm.interviewTime = item.interviewTime;
      this.appForm.leaveTime = item.leaveTime;
      this.appForm.company = item.company;
      this.appForm.carNo = item.carNo;
      this.appForm.reason = item.reason;
      this.appForm.openId = item.openId;
      this.appForm.visitors = item.visitors;
      this.appForm.visitors.forEach((items, index) => {
        this.$set(this.appForm.visitors[index], "healthCode", "");
        this.$set(this.appForm.visitors[index], "routeCode", "");
        this.$set(this.appForm.visitors[index], "acidCode", "");
        this.$set(this.appForm.visitors[index], "healthCodeList", []);
        this.$set(this.appForm.visitors[index], "routeCodeList", []);
        this.$set(this.appForm.visitors[index], "acidCodeList", []);
      });
      this.initContent(0);
    },
    // 添加访客按钮
    addVis() {
      this.appForm.visitors.push({
        personName: "",
        personNo: "",
        personPhone: "",
        sex: 0,
        age: null,
        apartment: "",
        journey: "",
        transport: "",
        hasCough: 0,
        hasRisk: 0,
        healthCode: "",
        routeCode: "",
        acidCode: "",
        healthCodeList: [],
        routeCodeList: [],
        acidCodeList: [],
        hasPass: 1,
        passNo: "",
        hasWorklicense: 1,
        worklicenseNo: "",
      });
      this.$set(this.appForm.visitors, this.appForm.visitors);
    },
    delVis(index, item) {
      Dialog({ message: "提示" });
      Dialog.confirm({
        title: "提示",
        message: `确认删除访客${item.personName}吗？`,
      })
        .then(() => {
          if (this.appForm.visitors.length > 1) {
            this.appForm.visitors.splice(index, 1);
          }
        })
        .catch(() => {});
    },
    // 选日期弹窗
    openPicker(picker_v) {
      this.picker_v = picker_v;
      this.showCalendar = true;
    },
    // 选日期弹窗
    onConfirm(date) {
      console.log(date);
      console.log(formatTime1("hm", date));
      if (this.picker_v == 1) {
        this.appForm.interviewTime = formatTime1("hm", date);
      } else {
        this.appForm.leaveTime = formatTime1("hm", date);
      }
      this.showCalendar = false;
    },
    cancel() {
      this.showCalendar = false;
    },
    checkPhone() {
      let registerCheckModel = {
        name: this.appForm.intervieweeName,
        phone: this.appForm.intervieweePhone,
      };
      registerCheck(registerCheckModel).then((res) => {
        if (res.code == 200) {
          this.$toast("校验通过");
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 文件上传
    afterRead(file, params) {
      console.log(file);
      console.log(params);
      let code = params.name.split(",")[0];
      let index = params.name.split(",")[1];
      // 此时可以自行将文件上传至服务器
      if (Array.isArray(file)) {
        for (let i = 0; i < file.length; i++) {
          file[i].file.status = "uploading";
          file[i].file.message = "上传中...";
          uploadImg({
            img: file[i].content,
            openId: localStorage.getItem("openId"),
            ext: file[i].file.name.split(".")[1],
          }).then((res) => {
            Toast("上传成功");
            if (code == 1) {
              this.appForm.visitors[index].healthCode +=
                ";" + res.result.savePath;
            } else if (code == 2) {
              this.appForm.visitors[index].routeCode +=
                ";" + res.result.savePath;
            } else if (code == 3) {
              this.appForm.visitors[index].acidCode +=
                ";" + res.result.savePath;
            }
            file[i].file.status = "done";
            file[i].file.message = "上传成功";
          });
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        uploadImg({
          img: file.content,
          openId: localStorage.getItem("openId"),
          ext: file.file.name.split(".")[1],
        }).then((res) => {
          Toast("上传成功");
          if (code == 1) {
            this.appForm.visitors[index].healthCode +=
              ";" + res.result.savePath;
          } else if (code == 2) {
            this.appForm.visitors[index].routeCode += ";" + res.result.savePath;
          } else if (code == 3) {
            this.appForm.visitors[index].acidCode += ";" + res.result.savePath;
          }
          file.status = "done";
          file.message = "上传成功";
        });
      }
      // setTimeout(()=>{
      // 	let str = this.appForm.visitors[index].healthCode
      // 	console.log(str.slice(0,1)==';'?str.slice(1):str);
      // },1200)
    },
    // 重置
    reset() {
      this.appForm = {
        intervieweeName: "",
        intervieweePhone: "",
        interviewTime: "",
        leaveTime: "",
        company: "",
        carNo: "",
        reason: "",
        openId: "",
        visitors: [
          {
            personName: "",
            personNo: "",
            personPhone: "",
            sex: 0,
            age: null,
            apartment: "",
            journey: "",
            transport: "",
            hasCough: 0,
            hasRisk: 0,
            healthCode: "",
            routeCode: "",
            acidCode: "",
            hasPass: 1,
            passNo: "",
            hasWorklicense: 1,
            worklicenseNo: "",
          },
        ],
      };
    },
    // 校验失败
    failed() {
      console.log(111);
    },
    // 提交预约
    async onSubmit() {
      this.appForm.openId = localStorage.getItem("openId") || "";
      let arr = this.appForm.visitors;
      this.appForm.visitors = [];
      arr.forEach((i, v) => {
        this.appForm.visitors.push({
          personName: i.personName,
          personNo: i.personNo,
          personPhone: i.personPhone,
          healthCode:
            i.healthCode.slice(0, 1) == ";"
              ? i.healthCode.slice(1)
              : i.healthCode,
          routeCode:
            i.routeCode.slice(0, 1) == ";" ? i.routeCode.slice(1) : i.routeCode,
          acidCode:
            i.acidCode.slice(0, 1) == ";" ? i.acidCode.slice(1) : i.acidCode,
          sex: i.sex,
          age: i.age,
          apartment: i.apartment,
          journey: i.journey,
          transport: i.transport,
          hasCough: i.hasCough,
          hasRisk: i.hasRisk,
          hasPass: i.hasPass,
          passNo: i.passNo,
          hasWorklicense: i.hasWorklicense,
          worklicenseNo: i.worklicenseNo,
        });
      });
      //校验是否有人员在黑名单
      console.log(this.appForm);
      //同步请求
      const res = await visitorBlacklist(this.appForm);
      let needSubmit = true;

      if (res.code == 8002) {
        //人员在黑名单中,让用户选择是否继续提交
        try {
          await Dialog.confirm({ title: "提示", message: res.message });
          console.log("继续提交");
          needSubmit = true;
        } catch (error) {
          console.log("取消");
          needSubmit = false;
          return; // Cancel submission
        }
      }
      if (needSubmit) {
        //提交预约
        addVisitor(this.appForm).then((res) => {
          if (res.code == 200) {
            this.$toast(res.message);
            this.reset();
          } else {
            this.$toast(res.message);
          }
        });
      }
    },
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      apptHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result.records;
          this.total = res.result.total;
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    onLoad() {
      console.log("加载更多");
      if (this.isLoading) return;
      this.pageNo++;
      apptHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          this.historyList = this.historyList.concat(res.result.records);
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 取消预约
    cancleApp(item) {
      Dialog({
        message: "提示",
      });
      Dialog.confirm({
        title: "提示",
        message: "确认取消吗？",
      })
        .then(() => {
          cancel({
            apppointId: item.uid,
          }).then((res) => {
            if (res.code == 200) {
              Toast(res.message);
              this.getHistoryList();
            } else {
              Toast(res.message);
            }
          });
        })
        .catch(() => {});
    },

    initContent(value) {
      this.active = value;
      if (value == 0) {
        // 刷新页面
      } else {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getHistoryList();
      }
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
body {
  height: 100%;
}
.homes {
  border-top: 1px solid #ccc;
  width: 100%;
  height: 100%;
}
.modals {
  position: relative;
  height: 100%;
  padding-bottom: 7vh !important;
}
.autoFixed {
  background: #f3f3f3;
  min-height: 100vh;
  padding: 0 20px;
  position: relative;
  .userBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #4597ff;
  }
  .userBtn1 {
    position: absolute;
    right: 20px;
    top: 85px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #55aa7f;
  }
  .userBtn2 {
    position: absolute;
    right: 20px;
    top: 150px;
    width: 134px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #4597ff;
  }
  .userBtn3 {
    position: absolute;
    right: 20px;
    top: 215px;
    width: 134px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #4597ff;
  }

  .main {
    box-sizing: content-box;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    border-radius: 5px;
    padding: 0 24px;
    box-sizing: border-box;
    position: relative;
    .roomName {
      position: absolute;
      left: 20px;
      top: 20px;
      color: #64b0ff;
      font-weight: bold;
    }

    .hisotry-right {
      position: absolute;
      right: 90px;
      top: 20px;
      img {
        width: 150px;
        height: 150px;
      }
      .quxiao {
        width: 150px;
        height: 130px;
      }
    }

    .history-item {
      margin-bottom: 15px;

      span {
        font-size: 28px;
        color: #333;
      }
    }
  }
}
// /deep/.van-picker-column__item{
// 	height: 84px !important;
// }
</style>
